import axios from 'axios'
import { API_SCOPES, msalInstance } from './MsalInstanceProvider'

export const api = axios.create()

// convenience method to return list of schools as options for a select list
// todo: could benefit from caching
export const getSchoolOptions = () => {
  return api.get('/public/schools').then(response => {
    const { data } = response
    return data.map(entry => {
      return {
        value: entry.OrgID,
        label: '(' + entry.OrgID + ') ' + entry.Name,
      }
    })
  })
}
export const putStudent = student => {
  return api.put(`/student/${student.permNumber}`, student)
}
export const postStudent = student => {
  return api.post('/student', student)
}
export const archiveSurvey = surveyId => {
  return api.put(`/archive/${surveyId}`)
}

async function getToken(forceRefresh = false) {
  // ensure we have an account
  const accounts = msalInstance.getAllAccounts()
  const account = msalInstance.getActiveAccount() || accounts[0]

  if (!account) {
    // not signed in yet — kick off interactive
    await msalInstance.loginRedirect({ scopes: API_SCOPES })
    return '' // redirect happens; code after won’t run
  }

  const req = { scopes: API_SCOPES, account, forceRefresh }
  try {
    const res = await msalInstance.acquireTokenSilent(req)
    return res.accessToken
  } catch (e) {
    // InteractionRequiredAuthError in plain JS: check by name
    if (e && e.name === 'InteractionRequiredAuthError') {
      await msalInstance.acquireTokenRedirect(req) // or acquireTokenPopup(req)
    }
    throw e
  }
}

api.interceptors.request.use(async cfg => {
  const url = cfg.url || ''
  if (url.startsWith('/public/')) {
    return cfg
  }
  cfg.headers = cfg.headers || {}
  cfg.headers.Authorization = `Bearer ${await getToken(false)}`
  return cfg
})

api.interceptors.response.use(undefined, async error => {
  const original = error.config || {}
  if (error.response && error.response.status === 401 && !original._retry) {
    original._retry = true
    original.headers = original.headers || {}
    original.headers.Authorization = `Bearer ${await getToken(true)}` // force refresh
    return axios(original)
  }
  return Promise.reject(error)
})
